// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DocumentsService } from '@services/documents.service';
import { UserPermissionIds } from '../../interfaces/user.interfaces';
import { ErrorModalComponent } from '../../modals/error-modal/error-modal.component';
import { PermissionsService } from '../../services/permissions.service';
import { UserService } from '../../services/user.service';
import { SettingsService } from '@services/settings.service';
import { from, takeWhile } from 'rxjs';
import { ContentService } from '@services/content.service';
import { Dealer } from '@interfaces/dealer.interfaces';
import { DealershipService } from '@services/dealership.service';

@Component({
    selector: 'app-pddj-status',
    templateUrl: './pddj-status.component.html',
    styleUrls: ['./pddj-status.component.scss'],
})
export class PddjStatusComponent implements OnInit, OnDestroy {
    private isComponentAlive: boolean = true;
    private dealer: Dealer;

    constructor(
        private readonly documentService: DocumentsService,
        private readonly router: Router,
        private readonly dialog: MatDialog,
        private readonly permissionService: PermissionsService,
        private readonly userService: UserService,
        private readonly settingsService: SettingsService,
        private readonly dealershipService: DealershipService,
        private readonly contentService: ContentService
    ) {
        this.dealershipService.dealer$.pipe(takeWhile(() => this.isComponentAlive)).subscribe((dealer) => {
            this.dealer = dealer;
        });
    }

    ngOnInit(): void {
        if (!this.permissionService.hasPermission(UserPermissionIds.PrintToDDJ)) {
            this.contentService
                .permissionsMissingError(this.dealer.oemCode)
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((message) => {
                    this.dialog
                        .open(ErrorModalComponent, {
                            width: '700px',
                            data: {
                                title: 'Access Restricted',
                                message,
                            },
                        })
                        .afterClosed()
                        .subscribe(() => {
                            this.userService.logOut();
                        });
                });
        } else {
            //when a document is pending upload it will navigate back to deals.
            if (this.documentService.pddjDocument || this.documentService.pddjDocumentQueue.some((x) => x)) {
                this.router.navigate(['/pddj', 'deals']);
            }

            const targetEl = document.querySelector('.pddj-info');
            targetEl.classList.add('pddj-desktop');
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
